import { createAction } from 'lib/reduxUtils';

export const SET_COURSE_COMPLETED = 'entities/courses/setCourseCompleted';
export const setCourseCompleted = createAction(SET_COURSE_COMPLETED);

export const SET_USER_DATA_ANONYMIZED = 'entities/courses/setUserDataAnonymized';
export const setUserDataAnonymized = createAction(SET_USER_DATA_ANONYMIZED);
